import React from 'react';
import ToolbarView from './View';
import useToolbar from './hooks/useToolbar';
const Toolbar = ({ quill, ...rowCenterProps }) => {
    const [toolbarState, toolbarActions] = useToolbar(quill);
    return toolbarState.mfFocused ? null : (React.createElement(ToolbarView, { ...rowCenterProps, mfFocused: toolbarState.mfFocused, actionsState: toolbarState.actionsState, onActionPress: toolbarActions.handleActionPress }));
};
export default Toolbar;
